import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteTaxServiceMutationVariables = Types.Exact<{
  taxServiceId: Types.Scalars["String"];
}>;

export type DeleteTaxServiceMutation = {
  __typename?: "Mutation";
  deleteTaxService: { __typename?: "MutationResult"; success: boolean };
};

export const DeleteTaxServiceDocument = gql`
  mutation deleteTaxService($taxServiceId: String!) {
    deleteTaxService(taxServiceId: $taxServiceId) {
      success
    }
  }
`;
export type DeleteTaxServiceMutationFn = Apollo.MutationFunction<
  DeleteTaxServiceMutation,
  DeleteTaxServiceMutationVariables
>;

/**
 * __useDeleteTaxServiceMutation__
 *
 * To run a mutation, you first call `useDeleteTaxServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaxServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaxServiceMutation, { data, loading, error }] = useDeleteTaxServiceMutation({
 *   variables: {
 *      taxServiceId: // value for 'taxServiceId'
 *   },
 * });
 */
export function useDeleteTaxServiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTaxServiceMutation,
    DeleteTaxServiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteTaxServiceMutation,
    DeleteTaxServiceMutationVariables
  >(DeleteTaxServiceDocument, options);
}
export type DeleteTaxServiceMutationHookResult = ReturnType<
  typeof useDeleteTaxServiceMutation
>;
export type DeleteTaxServiceMutationResult =
  Apollo.MutationResult<DeleteTaxServiceMutation>;
export type DeleteTaxServiceMutationOptions = Apollo.BaseMutationOptions<
  DeleteTaxServiceMutation,
  DeleteTaxServiceMutationVariables
>;
